import React, {FC} from "react"
import {MarkdownAtom, MarkdownBlock} from "../../model/markdown/MarkdownText"
import './MarkdownHeaderBlock.less'
import {AtomsViewer} from "../atoms/AtomsViewer"

interface MarkdownHeaderBlockProps {
    block: MarkdownBlock
    onToggleCheckBox: (atom: MarkdownAtom) => void
}

export const MarkdownHeaderBlock: FC<MarkdownHeaderBlockProps> = ({
                                                                      block,
                                                                      onToggleCheckBox
                                                                  }) => {
    const headerNo = block.type.toString().substring(block.type.length - 1)

    return (
        <div className={"block header header" + headerNo}>
            <AtomsViewer atoms={block.atoms} onToggleCheckBox={onToggleCheckBox}/>
        </div>
    )
}
